import { render, staticRenderFns } from "./WillLocationCard.vue?vue&type=template&id=aa037546"
import script from "./WillLocationCard.vue?vue&type=script&lang=js"
export * from "./WillLocationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports